import i18n from 'i18n'

interface ReminderOption {
  key: number
  label: string
}

export const REMINDER_OPTIONS = (): ReminderOption[] => {
  return [
    { key: 0, label: i18n.t('calendar.alarm.atTimeOfEvent') },
    { key: -300, label: i18n.t('calendar.alarm.5MinutesBefore') },
    { key: -600, label: i18n.t('calendar.alarm.10MinutesBefore') },
    { key: -900, label: i18n.t('calendar.alarm.15MinutesBefore') },
    { key: -1800, label: i18n.t('calendar.alarm.30MinutesBefore') },
    { key: -3600, label: i18n.t('calendar.alarm.1HourBefore') },
    { key: -7200, label: i18n.t('calendar.alarm.2HoursBefore') },
    { key: -43200, label: i18n.t('calendar.alarm.12HoursBefore') },
    { key: -86400, label: i18n.t('calendar.alarm.1DayBefore') },
    { key: -172800, label: i18n.t('calendar.alarm.2DaysBefore') },
    { key: -604800, label: i18n.t('calendar.alarm.1WeekBefore') },
  ]
}

export const ALLDAY_REMINDER_OPTIONS = (): ReminderOption[] => {
  return [
    { key: -54000, label: i18n.t('calendar.alarm.dayBeforeAt9AM') }, // -15 * 60 * 60
    { key: -25200, label: i18n.t('calendar.alarm.dayBeforeAt5PM') }, // -7 * 60 * 60
    { key: -561600, label: i18n.t('calendar.alarm.weekBeforeAt9AM') }, // -(15 * 60 * 60) + -(6 * 24 * 60 * 60)
  ]
}
